import React from "react";
import {
  ScreenFlow,
  RecruitmentSteps,
} from "../../components";

const flowarray = [
  { title: "Home", link: "/" },
  { title: "Find Trials", link: "/#find_trial" },
  {
    title: "Search Results",
    link: `/results?q=NCT04232280&in=UNITED%20STATES`,
  },
  {
    title: "Trial Details",
    link: `/study/NCT04232280`,
  },
];

class NCT04232280 extends React.Component {
  
  render() {
    return (
      <div>
        {this.props.location &&
        this.props.location.search &&
        this.props.location.search.indexOf("embed=true") !== -1 ? null : (
          <>
            <RecruitmentSteps step={"Review Trials"} />
            <div className="container d-flex align-items-center justify-content-start">
              <ScreenFlow flow={flowarray} />
            </div>
          </>
        )}
        <div className="container">
          <iframe style={{height:3000,width:'100%',border:'none'}} title="NCT04232280" src="https://connect.trialscope.com/studies/3471242f-0ea9-456f-80ab-88b90cd679ac?embed=1"></iframe>
        </div>
      </div>
    );
  }
}

export default NCT04232280;
